// extracted by mini-css-extract-plugin
export default {"link":"UiFileLink_link","disabled":"UiFileLink_disabled","icon":"UiFileLink_icon","text":"UiFileLink_text","size":"UiFileLink_size"};